export default __webpack_public_path__ + "static/media/search-service.4fb1d012.svg";